import { useEffect, useMemo, useRef, useState } from "react";
import useWebSocket from 'react-use-websocket';

/**
 * props:
 * - text
 * - type
 */
function Toast(props) {

    const DEFAULT_NOTIFICATION = { type: '', text: '' };

    const [notification, setNotification] = useState(DEFAULT_NOTIFICATION);
    const lastNotificationRef = useRef('');

    useEffect(() => {
        if (!notification.text) return;

        const notyf = new window.Notyf({
            position: {
                x: 'right',
                y: 'top',
            },
            duration: 0,
            types: [
                {
                    type: 'info',
                    background: 'blue',
                    dismissible: true
                },
                {
                    type: 'error',
                    background: 'red',
                    dismissible: true
                },
                {
                    type: 'success',
                    background: 'green',
                    dismissible: true
                }
            ]
        });

        // Garante que há uma mensagem válida
        const message = notification.text || notification.message || 'Erro desconhecido';
        const type = notification.type || 'error';
        
        // Se a mensagem contém "undefined", substitui por mensagem padrão
        const cleanMessage = message.toString().replace(/undefined/g, '').trim() || 'Erro desconhecido';
        
        const toast = notyf.open({
            type: type,
            message: cleanMessage
        });

        // Fecha ao clicar no X ou em qualquer lugar do toast
        if (toast) {
            toast.on('dismiss', ({ target, event }) => {
                setNotification(DEFAULT_NOTIFICATION);
            });

            // Adiciona listener de click no elemento do toast para fechar ao clicar nele
            setTimeout(() => {
                // Busca o toast mais recente (último da lista)
                const toastElements = document.querySelectorAll('.notyf__toast');
                const toastElement = toastElements[toastElements.length - 1];
                
                if (toastElement) {
                    // Adiciona cursor pointer para indicar que é clicável
                    toastElement.style.cursor = 'pointer';
                    
                    // Adiciona listener de click para fechar o toast
                    const handleClick = (e) => {
                        // Não fecha se clicar especificamente no botão X (deixa o comportamento padrão do Notyf)
                        if (e.target.classList.contains('notyf__dismiss') || 
                            e.target.closest('.notyf__dismiss')) {
                            return;
                        }
                        // Usa a instância do Notyf para fechar a notificação
                        notyf.dismiss(toast);
                    };
                    
                    toastElement.addEventListener('click', handleClick);
                }
            }, 50);
        }
        //setNotification(DEFAULT_NOTIFICATION);
    }, [notification])

    useEffect(() => {
        setNotification({ type: props.type, text: props.text });
    }, [props.type, props.text])

    const shouldConnect = props.enableSocket === true;

    function parseJwtPayload(token) {
        try {
            const parts = String(token || '').split('.');
            if (parts.length < 2) return null;
            const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
            return JSON.parse(window.atob(payload));
        } catch {
            return null;
        }
    }

    function isTokenExpired(token) {
        const payload = parseJwtPayload(token);
        if (!payload || !payload.exp) return true;
        const nowInSeconds = Math.floor(Date.now() / 1000);
        return payload.exp <= nowInSeconds;
    }

    function handleExpiredSession() {
        try {
            localStorage.removeItem('token');
        } catch (err) {
            console.error('Erro ao limpar token expirado', err);
        }
        if (window.location.pathname !== '/') {
            window.location = '/';
        }
    }

    const token = localStorage.getItem("token");
    const hasValidToken = Boolean(token) && !isTokenExpired(token);
    const queryParams = useMemo(() => ({ token }), [token]);

    const { lastJsonMessage } = useWebSocket(process.env.REACT_APP_WS_URL, {
        onOpen: () => {
            if (shouldConnect) console.log(`Connected to App WS`);
        },
        queryParams,
        onError: (event) => {
            if (typeof document !== 'undefined' && document.visibilityState === 'hidden')
                return;
            console.error(event);
        },
        share: true,
        shouldReconnect: () => {
            if (!shouldConnect) return false;
            const latestToken = localStorage.getItem('token');
            const valid = Boolean(latestToken) && !isTokenExpired(latestToken);
            if (!valid) {
                handleExpiredSession();
                return false;
            }
            return true;
        },
        reconnectInterval: 3000
    }, shouldConnect && hasValidToken);

    useEffect(() => {
        if (!lastJsonMessage || !lastJsonMessage.notification) return;

        const nextNotification = lastJsonMessage.notification;
        const serialized = JSON.stringify(nextNotification);
        if (serialized === lastNotificationRef.current) return;

        lastNotificationRef.current = serialized;
        setNotification(nextNotification);
    }, [lastJsonMessage]);

    return (
        <></>
    )
}

export default Toast;